/**
 * @generated SignedSource<<013c05bbfa4f39d66859bbb164c23e9c>>
 * @relayHash f9d0b90da3fc5ded2446408a12ea4e88
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 43ba1f1f42df9ff9b2fe51ffd0f591e132b204d251b4582bec9fa29cdab19c8b

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type csmRequestDetailsQuery$variables = {
  cloudId: string;
  helpCenterId: string;
  issueKey: string;
};
export type csmRequestDetailsQuery$data = {
  readonly customerService: {
    readonly requestByIssueKey: {
      readonly __typename: "CustomerServiceRequest";
      readonly " $fragmentSpreads": FragmentRefs<"formView_csmRequestDetails" | "header_csmRequestDetails">;
    } | {
      readonly __typename: "QueryError";
      readonly " $fragmentSpreads": FragmentRefs<"throwOnQueryError_csmCommon">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  };
};
export type csmRequestDetailsQuery = {
  response: csmRequestDetailsQuery$data;
  variables: csmRequestDetailsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "helpCenterId",
    "variableName": "helpCenterId"
  },
  {
    "kind": "Variable",
    "name": "issueKey",
    "variableName": "issueKey"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "question"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "csmRequestDetailsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v3/*: any*/),
          "concreteType": "CustomerServiceQueryApi",
          "kind": "LinkedField",
          "name": "customerService",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v4/*: any*/),
                "kind": "LinkedField",
                "name": "requestByIssueKey",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "header_csmRequestDetails"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "formView_csmRequestDetails"
                      }
                    ],
                    "type": "CustomerServiceRequest"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "throwOnQueryError_csmCommon"
                      }
                    ],
                    "type": "QueryError"
                  }
                ]
              },
              "action": "THROW",
              "path": "customerService.requestByIssueKey"
            }
          ]
        },
        "action": "THROW",
        "path": "customerService"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "csmRequestDetailsQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "CustomerServiceQueryApi",
        "kind": "LinkedField",
        "name": "customerService",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "requestByIssueKey",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "summary"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "createdOn"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "statusKey"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "externalStatus"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "statusCategoryName"
                  },
                  {
                    "concreteType": "CustomerServiceRequestParticipant",
                    "kind": "LinkedField",
                    "name": "participants",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "displayName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "accountId"
                      }
                    ]
                  },
                  {
                    "concreteType": "CustomerServiceRequestFormDataConnection",
                    "kind": "LinkedField",
                    "name": "formData",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "CustomerServiceRequestFormDataEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "textAnswer"
                                  }
                                ],
                                "type": "CustomerServiceRequestFormEntryTextField"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "adfAnswer"
                                  }
                                ],
                                "type": "CustomerServiceRequestFormEntryRichTextField"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "multiSelectTextAnswer"
                                  }
                                ],
                                "type": "CustomerServiceRequestFormEntryMultiSelectField"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "fileIds"
                                  }
                                ],
                                "type": "CustomerServiceRequestFormEntryAttachmentField"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "CustomerServiceRequest"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "identifier"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "statusCode"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "errorType"
                      }
                    ]
                  }
                ],
                "type": "QueryError"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "43ba1f1f42df9ff9b2fe51ffd0f591e132b204d251b4582bec9fa29cdab19c8b",
    "metadata": {},
    "name": "csmRequestDetailsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0d1145658682357d33bf4a6df047b2d0";

export default node;
